import { FAQS } from "../data/siteConfig";
import { useSEO } from "../components/SEO";
import FadeIn from "../components/FadeIn";
import FaqAccordion from "../components/FaqAccordion";
import FinalCTA from "../components/FinalCTA";

const FaqPage = () => {
  useSEO(
    "FAQ | Dr Lal PathLabs Collection Center Bhopal",
    "Frequently asked questions about booking diagnostic tests, home sample collection, test prices and reports at Dr Lal PathLabs Collection Center Bhopal."
  );

  return (
    <div>
      <section className="bg-[#0B3056] py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <FadeIn>
            <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-blue-200">Help Center</p>
            <h1 className="font-heading text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
              Frequently Asked Questions
            </h1>
            <p className="mt-4 max-w-2xl text-base text-blue-100 md:text-lg">
              Quick answers about booking tests, home sample collection, prices and reports.
            </p>
          </FadeIn>
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8">
        <FaqAccordion items={FAQS} prefix="faq-page" />
      </section>

      <FinalCTA heading="Still Have a Question?" text="Our collection center team is happy to help with test and appointment enquiries." />
    </div>
  );
};

export default FaqPage;
